import { atom } from "jotai";
import { atomWithDefault } from "jotai/utils";
import { sessionAtom } from "../accounts/account.state";
import { appState } from "../app/app.state";
import { getProductDb } from "./product.service";

const baseProductDbAtom = atomWithDefault(async (get) => {
  const session = await get(sessionAtom);
  return session?.account?.config
    ? await getProductDb(session.account.config.imageStorageUrl)
    : null;
});

export const productDbAtom = atom(
  async (get) => {
    const db = await get(baseProductDbAtom);
    return db;
  },
  (_get, set, update) => {
    set(baseProductDbAtom, update);
    appState.data_dirty = true;
  }
);
